'use client';

import type {FC, ReactNode} from 'react';
import {Disclosure} from '@headlessui/react';
import {ChevronDownIcon, ChevronUpIcon} from '@heroicons/react/20/solid';
import clsx from 'clsx';

interface FooterLinksProps {
	title?: string;
	children: ReactNode;
}

export const FooterLinks: FC<FooterLinksProps> = ({
	title,
	children,
}: FooterLinksProps) => {
	return (
		<>
			<Disclosure as="div" className={clsx('xl:hidden')}>
				{({open}) => (
					<>
						<div
							className={clsx(
								'inline-block',
								'focus-within:ring-focus-dark',
								'rounded',
								'-mx-4',
								'px-4',
								'w-full',
								'box-content',
							)}
						>
							<Disclosure.Button
								className={clsx(
									'flex',
									'items-end',
									'justify-between',
									'text-left',
									'gap-1',
									'py-2',
									'focus:ring-disabled',
									'w-full',
									'pr-2',
									'border-b',
									'border-turquoise-700',
								)}
							>
								<span
									className={clsx(
										'font-medium',
										'text-sm',
										'md:text-2xl',
									)}
								>
									{title}
								</span>
								{open ? (
									<ChevronUpIcon
										className={clsx('h-6', 'w-6')}
										aria-hidden="true"
									/>
								) : (
									<ChevronDownIcon
										className={clsx('h-6', 'w-6')}
										aria-hidden="true"
									/>
								)}
							</Disclosure.Button>
						</div>
						<Disclosure.Panel
							className={clsx(
								'w-full',
								'pt-4',
								'pb-12',
								'font-normal',
								'text-sm',
								'md:text-lg',
							)}
						>
							{children}
						</Disclosure.Panel>
					</>
				)}
			</Disclosure>
			<nav className={clsx('hidden', 'xl:block')} aria-label={title}>
				<h2 className={clsx('text-pMedium', 'mb-6')}>{title}</h2>
				<div className={clsx('font-normal', 'text-lg')}>{children}</div>
			</nav>
		</>
	);
};
